<template>
  <VuePerfectScrollbar class="bb-sidebar"
                       @ps-scroll-x="scrollX"
                       @mouseenter="sidebarShow()"
                       :class="{
                         'bb-sidebar_fire': fire,
                         'bb-sidebar_open': sidebarOpen}">
    <profile
      :sidebarOpen.sync="sidebarOpen"
      @updateActiveMenu="updateActiveMenu"
    />
    <nav class="bb-sidebar-menu">
      <div v-for="(menuElem,index) in menu"
           :key="menuElem.id"
           class="bb-sidebar-menu__item"
           :class="{
           'bb-sidebar-menu__item_active': submenuOpen === index,
           'bb-sidebar-menu__item_save':activeSubmenu === index
           }"
           v-show="checkAccess(menuElem)">
        <div class="bb-sidebar-menu__link" @click="goToRoute(index, menuElem)">
        <div class="bb-sidebar-menu__icon-wrapper">
          <template
            v-if="!!menuElem.iconComponent"
          >
            <span v-html="menuElem.iconComponent"></span>
          </template>
          <i v-else
             :class="`icon-`+menuElem.icon"
          />
        </div>
        <transition name="fade">
          <span class="bb-sidebar-menu__text">
            {{isFounder && menuElem.titleFounder ? menuElem.titleFounder : menuElem.title}}
          </span>
        </transition>
      </div>
        <transition name="fade-submenu">
          <ul v-if="submenuOpen === index" class="bb-sidebar-submenu">
            <li class="bb-sidebar-submenu__item"
                v-for="(submenuElem) in menuElem.submenu"
                :key="submenuElem.id"
                :class="{'bb-sidebar-submenu__item_active': submenuActiveElem === submenuElem.id}"
                @click.stop="goToSubRoute(submenuElem, submenuElem.id)"
                v-if="checkAccess(menuElem, submenuElem)">
              <span>
                {{isFounder && submenuElem.titleFounder ? submenuElem.titleFounder : submenuElem.title}}
              </span>
            </li>
          </ul>
        </transition>
      </div>
    </nav>
    <div class="bb-sidebar-footer">
      <email-link
        :sidebar-open="sidebarOpen"
        :isActiveEmail="isActiveEmail"
        @goToRouteEmail="goToRouteEmail"
      />
      <notification-indicator :sidebarOpen="sidebarOpen"/>
      <companyList :sidebarOpen="sidebarOpen"/>
      <TechnicalSupportButton
        :isFounder="isFounder"
        @onOpenModal="isSupportModal = true"
      />
    </div>
    <TechnicalSupportModal
      :isSupportModal="isSupportModal"
      :loader.sync="loader"
      @close="closeSupportModal"
    />
    <BBModalWindowInfo
      v-if="isInfoModal"
      :settings="settingsModal"
      @onClose="isInfoModal = false"
    />
  </VuePerfectScrollbar>
</template>

<script>
import Profile from './Profile/Profile'
import CompanyList from './CompanyList/CompanyList'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CompaniesApi from '@/api/Companies/api'
import {menu} from '@/constants/menu'
import {FOUNDER, CEO, ACCOUNTANT, CRM_ENTRY_USER, CRM_SUPER_USER} from '@/constants/roles'
import { OkIcon, UnsaveIcon } from '@/constants/icon'
import {get} from 'lodash'
import EmailLink from '@/components/Main/EmailLink/EmailLink'
import checkToken from '@/mixin/checkToken'
import NotificationIndicator from '@/components/Notifications/NotificationIndicator'
import TechnicalSupportButton from '@/components/TechnicalSupport/TechnicalSupportButton/TechnicalSupportButton'
import TechnicalSupportModal from '@/components/TechnicalSupport/TechnicalSupportModal/TechnicalSupportModal'
import BBModalWindowInfo from '@/components/Main/ModalWindow/BBModalWindowInfo'

export default {
  name: 'Sidebar',
  components: {
    BBModalWindowInfo,
    TechnicalSupportModal,
    TechnicalSupportButton,
    NotificationIndicator,
    EmailLink,
    Profile,
    CompanyList,
    VuePerfectScrollbar
  },
  mixins: [checkToken],
  props: {
    loaderRun: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fire: false,
      userInfoReady: false,
      activeSubmenu: false,
      sidebarOpen: true,
      submenuOpen: null,
      submenuActiveElem: false,
      isActiveEmail: false,
      menu: menu,
      isSupportModal: false,
      isInfoModal: false,
      settingsModal: {}
    }
  },
  computed: {
    loader: {
      get () {
        return this.loaderRun
      },
      set (data) {
        this.$emit('update:loaderRun', data)
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    isFounder () {
      return this.userInfo.role === FOUNDER.id
    }
  },
  methods: {
    closeSupportModal (status) {
      this.isSupportModal = false
      if ((status === 200) || (status === 500)) {
        setTimeout(() => {
          this.isInfoModal = true
        }, 200)
      }
      if (status === 200) {
        this.settingsModal = {
          title: 'The suggestion has been was successfully sent',
          icon: OkIcon,
          color: 'green'
        }
      }
      if (status === 500) {
        this.settingsModal = {
          title: 'Error sending the suggestion',
          description: 'Try again, please.',
          icon: UnsaveIcon,
          color: 'red'
        }
      }
      setTimeout(() => {
        this.isInfoModal = false
      }, 2000)
    },
    getCompany: function () {
      CompaniesApi.getCompanies()
        .then((resp) => {
          this.companiesList = resp.data.companies
        })
        .catch((err) => {
          console.error(err)
        })
    },
    updateActiveMenu (isHr) {
      if (isHr) {
        const index = menu.findIndex((el) => el.access === 'hr')
        this.submenuOpen = index
        this.activeSubmenu = index
        const element = menu[index]
        const { submenu } = element
        const subElem = submenu.find((el) => el.access === 'EmployeesList')
        if (!subElem) return
        const { id } = subElem
        this.submenuActiveElem = id
      } else {
        this.closeOpenMenu()
      }
    },
    closeOpenMenu () {
      this.submenuActiveElem = false
      this.submenuOpen = false
      this.activeSubmenu = false
    },
    goToRouteEmail () {
      this.closeOpenMenu()
      this.isActiveEmail = true
      if (this.$route.path === '/mail') return
      this.$router.push({'path': '/mail'}).catch(err => err)
    },
    goToRoute: function (index, menuElem) {
      this.isActiveEmail = false
      let accessUser = true
      if (menuElem.title !== 'Settings') {
        const elemMenu = get(menuElem, 'access', '')
        accessUser = get(this.userInfo, ['access', elemMenu, elemMenu], false)
      }
      this.submenuOpen = index
      this.activeSubmenu = index
      const role = this.isFounder || this.userInfo.role === CEO.id
      const { department } = menuElem
      const departmentUser = get(this.userInfo, 'position.department', false)
      const isDepartmentUser = department && !this.isFounder ? department === departmentUser : true
      const access = accessUser || role
      if (menuElem.route && this.$route.name !== menuElem.route && (access || isDepartmentUser)) {
        this.$router.push({'name': menuElem.route}).catch(err => err)
      }
      if (menuElem.title === 'Settings' || menuElem.title === 'HR') return
      this.submenuActiveElem = false
    },
    goToSubRoute: function (menuElem, id) {
      this.isActiveEmail = false
      this.submenuActiveElem = id
      const route = menuElem.route
      if (route && this.$route.name !== route) {
        const paramsRoute = {
          name: route
        }
        if (menuElem.params) {
          paramsRoute.params = menuElem.params
        }
        this.$router.push(paramsRoute).catch(err => err)
      }
    },
    sidebarHide: function () {
      this.activeSubmenu = this.submenuOpen
      this.submenuOpen = false
      this.sidebarOpen = false
    },
    sidebarShow: function () {
      this.submenuOpen = this.activeSubmenu
      this.sidebarOpen = true
    },
    scrollX (e) {
      e.target.scrollLeft = 0
    },
    checkAccess (menuItem, submenuItem) {
      const isCeo = this.userInfo.role === CEO.id
      const isAccountant = this.userInfo.role === ACCOUNTANT.id
      const isCrmEntryUser = this.userInfo.role === CRM_ENTRY_USER.id
      const isCrmSuperUser = this.userInfo.role === CRM_SUPER_USER.id

      if (this.isFounder) return true

      if ((menuItem.title === 'CRM') && !submenuItem && (isCrmEntryUser || isCrmSuperUser)) return true

      if ((menuItem.title === 'CRM' || menuItem.title === 'Finance') && isAccountant) return true

      if (menuItem.title === 'Settings') return this.isFounder || isCeo

      if (!this.userInfo.access) return false

      if (get(submenuItem, 'title', '') === 'Companies' && !this.isFounder) return false

      const access = get(this.userInfo.access, [menuItem.access], false)

      if (!submenuItem && access) {
        const values = Object.values(access)
        return !values.every(item => item === false)
      }

      const { department } = menuItem

      if (department) {
        const departmentUser = get(this.userInfo, 'position.department', false)
        const isDepartmentUser = department && !this.isFounder && !isCeo ? department === departmentUser : true
        return isDepartmentUser
      }

      if (Object.keys(this.userInfo.access).length > 0) {
        const menuAccess = get(this.userInfo.access, menuItem.access, {})
        const subAccess = get(submenuItem, 'access', {})
        const submenuAccess = get(menuAccess, subAccess, false)
        return submenuAccess
      }
    },
    indexActiveMenu (menu) {
      const { name, path } = this.$route
      return menu.findIndex((el) => {
        if (name) {
          return el.route === name
        } else {
          return el.path === path
        }
      })
    },
    setActiveMenu () {
      const index = this.indexActiveMenu(this.menu)
      if (index !== -1) {
        this.submenuOpen = index
        this.activeSubmenu = index
      } else {
        this.menu.forEach((item, index) => {
          const submenuIndex = this.indexActiveMenu(this.menu[index].submenu)
          if (submenuIndex === -1) return false
          this.submenuOpen = index
          this.activeSubmenu = index
          this.submenuActiveElem = this.menu[index].submenu[submenuIndex].id
        })
      }
    },
    activeCompany () {
      return this.$store.getters.activeCompany
    }
  },
  watch: {
    activeCompany (oldVal) {
      if (this.oldVal) {
        this.setActiveMenu()
      }
    },
    userInfo (oldVal, newVal) {
      if (newVal.firework) {
        this.setActiveMenu()
        this.fire = false
      }
    },
    $route () {
      this.checkToken()
    }
  },
  beforeMount () {
    if (!this.userInfo.firework) {
      this.setActiveMenu()
    } else {
      this.fire = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../sass/variables";
  @import "../../sass/transition";
  @import "../../sass/mixins";

  .bb-sidebar {
    @include global-font-light;
    display: grid;
    grid-template-rows: 77px 1fr auto;
    align-content: start;
    width: 81px;
    min-width: 81px;
    height: 100vh;
    background-color: $color-accent;
    transition: all 150ms;
    overflow: hidden;

    &_fire {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 200;
      background-color: transparent;
      pointer-events: none;
    }

    &-menu {
      width: 279px;
      height: auto;
      display: flex;
      flex-direction: column;
      padding: 50px 20px;
      color: $color-white;
      user-select: none;

      &__link {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        z-index: 1;
      }

      &__item {
        position: relative;
        display: flex;
        align-items: center;
        margin: 10px 0;
        cursor: pointer;

        &:after {
          position: absolute;
          top: 20px;
          left: 20px;
          content: "";
          width: 0;
          height: 0;
          border-radius: 10px;
          transition: all 150ms;
        }

        &:hover:after {
          top: 0;
          left: 0;
          width: 41px;
          height: 41px;
          background-color: $color-accent-hover;
        }

        &_save {
          &:after {
            top: 0;
            left: 0;
            border-radius: 10px;
            width: 41px;
            height: 41px;
            background-color: $color-accent-hover;
            transition: all 200ms;
          }
        }

        &_active {
          position: relative;
          flex-wrap: wrap;

          &:after,
          &:hover:after {
            top: 0;
            left: 0;
            border-radius: 10px 0 0 10px;
            width: calc(100% + 20px);
            height: calc(100%);
            background-color: $color-accent-hover;
            transition: all 200ms;
          }
        }
      }

      &__icon-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 41px;
        width: 41px;
        height: 41px;

        i {
          z-index: 1;
        }
      }

      &__text {
        flex-basis: 70%;
        margin-left: 10px;
        margin-right: auto;
        white-space: nowrap;
        font-size: 14px;
        line-height: 17px;
        z-index: 1;
      }
    }

    &_open {
      width: 279px;
      min-width: 279px;
    }

    &-submenu {
      flex-grow: 1;
      font-size: 12px;
      line-height: 14px;
      z-index: 1;
      padding-left: 44px;
      white-space: nowrap;

      &__item {
        margin: 14px 0 0 10px;
        opacity: 0.8;

        &_active,
        &:hover {
          opacity: 1
        }

        &:last-child {
          margin-bottom: 20px;
        }
      }
    }

    &-footer {
      max-width: 279px;
      margin: auto 0 30px 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Sidebar.vue